import React, { useMemo } from 'react';
// import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import HeaderTypography from 'components/Common/HeaderTypography';
import TitleBar from 'components/Common/TitleBar';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import CPASDashboard from './CPASDashboard';
import SSCDashboard from './SSCDashboard';
import HintDashboard from './HintDashBoard';
import Styles from './index.module.css';

const steps = [
  '我的廣告',
  '素材設定',
];

const SettingTypes = {
  CPAS: 'cpas',
  SSC: 'ssc',
};

const SettingTypeRoutes = {
  '/FbResourceSetting': SettingTypes.CPAS,
  '/GoogleResourceSetting': SettingTypes.SSC,
};

const SettingTitles = {
  [SettingTypes.CPAS]: 'Facebook CPAS素材設定',
  [SettingTypes.SSC]: 'Google SSC素材設定',
};

function ResourceSetting() {
  const location = useLocation();
  const settingType = useMemo(() => SettingTypeRoutes[location.pathname], [location.pathname]);

  return (
    <div className={Styles.resourceSettingContainer}>
      <div className={Styles.resourceSettingSide}>
        <HintDashboard />
      </div>
      <div className={classNames(
        Styles.resourceSettingBody,
        { [Styles.resourceSettingBodyNarrow]: settingType === SettingTypes.CPAS },
      )}
      >
        <HeaderTypography>{SettingTitles[settingType]}</HeaderTypography>
        <Box marginBottom={5}><TitleBar steps={steps} /></Box>
        {settingType === SettingTypes.CPAS && <CPASDashboard />}
        {settingType === SettingTypes.SSC && <SSCDashboard />}
      </div>
    </div>
  );
}

export default ResourceSetting;
